export default __webpack_public_path__ + "static/14-south-central-coast-label-ef57b03fd39b3a7ebe31a1fb2d930f71.svg";